export default __webpack_public_path__ + "static/media/instagram.2153f021.png";